<template>
  <div :id="'ex-' + categoryId" class="p-g01-item-list-group">
    <G01ItemListGroupHeader
      :id="categoryId"
      :label="categoryLabel"
      :is-category="isCategory"
      :is-first="isFirst"
    />
    <template>
      <G01ItemList
        v-if="isSp"
        :items="items"
        :list-name="categoryId"
        :is-category="isCategory"
        class="p-g01-item-list-group__list"
      />
      <G01ItemCarousel
        v-else
        :items="items"
        :carousel-name="categoryId"
        class="p-g01-item-list-group__carousel"
      />
    </template>
  </div>
</template>

<script lang="ts">
import G01ItemListGroupHeader from "@/general/components/pages/parts/Ranking/G01ItemListGroupHeader.vue";
import G01ItemList from "@/general/components/pages/parts/Ranking/G01ItemList.vue";
import G01ItemCarousel from "@/general/components/pages/parts/Ranking/G01ItemCarousel.vue";
import { Options, Vue } from 'vue-class-component';
import globals from "@/general/store/modules/globals";

@Options({
  props: {
    categoryId: { type: String, required: true, default: "" },
    categoryLabel: { type: String, required: true, default: "" },
    items: { type: Array, required: true, default: () => ([]) },
    isCategory: { type: Boolean, required: true, default: true },
    isFirst: { type: Boolean, required: false, default: false }
  },
  components: {
    G01ItemListGroupHeader,
    G01ItemList,
    G01ItemCarousel
  }
})
export default class G01ItemListGroup extends Vue {
  categoryId!: string;
  categoryLabel!: string;
  items!: any;
  isCategory!: boolean;
  isFirst!: boolean;

  get isSp() {
    return globals?.isLargeBreakpointWidthOfSp;
  }
}
</script>

<style lang="scss" scoped>
.p-g01-item-list-group {
  &__list {
    margin-top: rem(24);
  }

  &__carousel {
    max-width: rem(1295);
    margin: rem(24) auto 0;
  }
}
</style>
